<script>
    import { twoLineAddressOfMappable, coordLines } from "../../scripts/wpn2Model.js";
    // import {sensorPathsSummary } from "../../scripts/wpn2NHM.js"
    // import sysData from "../../Stores/systemStore.js";
    import schemaData from "../../Stores/wpn2SchemaStore.js"
    // import dbData from "../../Stores/utilityDBStore.js"

    // Display divs side by side: https://coder-coder.com/display-divs-side-by-side/
    export let item;
    let addressLines;
    let coords;
    // let sensorPaths;

    $: addressLines = twoLineAddressOfMappable(item) ?? ["No address", ""];
    $: coords = coordLines(item, $schemaData);
    // $: sensorPaths = sensorPathsSummary(item, $dbData.all, $sysData);
</script>

<div class="detail-section loc-container">
    <div class="detail-section-title">Location</div>
    <div class="loc-info">
        <div id="loc-address">
            <p class="address-line">{addressLines[0]}</p>
            <p class="address-line">{addressLines[1]}</p>
        </div>
        <div class="loc-coord">
            <p class="address-line">{coords[0]}</p>
            <p class="address-line">{coords[1]}</p>
        </div>
    {#if item.verified}
            <img
                id="verified"
                src="images/iconVerification.png"
                alt="Location verified"
            />
        {/if}
    </div>
    <!-- {#if item.entity == "NoiseSource"}
        <div id="sensor-paths">
            {#each sensorPaths as path}
                <div class="color-band">
                    <div
                        class="path-band"
                        style="background-color:{path.color}"
                    />
                    <div class="path-label">{path.title}</div>
                </div>
            {/each}
        </div>
    {/if} -->
</div>

<style>
    .loc-container {
        margin: 0 auto;
    }
    .loc-info {
        display: flex;
        position: relative;
    }
    #loc-address {
        flex: 1;
        padding: 4px 0;
    }
    .address-line {
        margin-block-start: 0;
        margin-block-end: 0.25rem;
    }
    .loc-coord {
        flex: 1;
        text-align: right;
        padding: 4px 0;
        color: gray;
        font-size: 0.75rem;
    }
    #verified {
        position: absolute;
        top: 0;
        right: 0;
        width: 32px;
        height: 32px;
    }
    /* #sensor-paths {
        width: fit-content;
        padding: 8px;
        margin: 0 auto;
    }
    .color-band {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        margin: auto;
    }
    .path-band {
        width: 16px;
        height: 2px;
        padding-left: 32px;
    }
    .path-label {
        padding: 2px 8px;
    } */
</style>
